module.exports = __webpack_public_path__ + "img/wxshtip.af6122aa.png";